import StartProvider from '@atlassiansox/cross-flow-support/start';
import React, { ComponentType } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import { AnalyticsConsumerProps, withAnalytics } from '../../hoc/withAnalytics';
import { useFabricAnalyticsListenerAdapter } from '../../hooks/useFabricAnalyticsListener';

const CrossFlowProvider: ComponentType<InjectedIntlProps & AnalyticsConsumerProps> = props => {
  const { intl, children } = props;
  const fabricAnalyticsListener = useFabricAnalyticsListenerAdapter();

  return (
    <StartProvider analyticsClient={fabricAnalyticsListener} locale={intl.locale}>
      {children}
    </StartProvider>
  );
};

export default injectIntl(withAnalytics(CrossFlowProvider));
